import {
  Button,
  HeadTitle,
  MenuBottomsheet,
  Popup,
  SelectField,
  Spacer,
  TextField,
  Tmd14,
} from 'oui';
import { useMtgConditions } from '../../../application/bloc/useMtgConditions';
import { useMtgConfirm } from '../../../application/bloc/useMtgConfirm';
import { currencyKR } from '../../../application/helper/filter';
import { FloatingBox, Height60, SideBox } from '../../etc/LBox/LBox';

export const MtgConfirm = () => {
  const {
    navigate,
    selectSheet,
    openSelectSheet,
    mortgageInfo,
    onChangeWrappingInput,
    onChangeInput,
  } = useMtgConditions();

  const {
    isActive,
    popup,
    onClickPopupField,
    navigateFromMtg,
    sendBeaconClkBtnNext,
    sendBeaconClkBtnOption,
  } = useMtgConfirm();

  const onClickButton = async () => {
    sendBeaconClkBtnNext();
    navigateFromMtg();
  };

  const onClickSelectField = (type: string) => {
    openSelectSheet(type);
  };

  const getHelpHousePrice = () => {
    if (mortgageInfo?.housePrice) {
      if (
        typeof mortgageInfo.housePrice == 'string' &&
        mortgageInfo.housePrice.includes('원')
      ) {
        return ` ${mortgageInfo.housePrice}`;
      } else {
        const value = currencyKR(mortgageInfo.housePrice * 10000);
        if (value !== '0원') {
          return ` ${value}`;
        }
      }
    }
    return '';
  };

  return (
    <>
      <HeadTitle
        textTitle={'드디어 마지막이에요!\n 입력하신 정보를 확인해 주세요'}
      />
      <Spacer size={'xs'} />
      <SideBox>
        <SelectField
          inputTitle="대출 목적"
          value={mortgageInfo.purposeCd.text}
          placeholder={'대출 목적'}
          onChangeSelectField={() => {}}
          onClickSelectField={() =>
            onClickPopupField('대출 목적', () =>
              navigate('/mtg/conditions/1', {
                state: { ref_page: '/conditions/7' },
              }),
            )
          }
        />
        <Spacer size={'md'} />
        <SelectField
          inputTitle="주택 정보"
          value={
            mortgageInfo.houseType.value === '30'
              ? mortgageInfo.ldongCode.text
              : mortgageInfo.apartment.text
          }
          placeholder={'주택 정보'}
          helperText={
            mortgageInfo.houseType.value !== '30'
              ? mortgageInfo.rateSeq.text + getHelpHousePrice()
              : ''
          }
          onChangeSelectField={() => {}}
          onClickSelectField={() =>
            onClickPopupField('주택 정보', () =>
              navigate('/mtg/conditions/3', {
                state: { ref_page: '/conditions/7' },
              }),
            )
          }
        />
        {mortgageInfo.purposeCd.value === '10' && (
          <>
            <Spacer size={'md'} />
            <SelectField
              inputTitle="생애 첫 주택 구매 여부"
              value={mortgageInfo.firstYn.text}
              placeholder={'생애 첫 주택 구매 여부'}
              onChangeSelectField={() => {}}
              onClickSelectField={() => onClickSelectField('C04910')}
            />
          </>
        )}

        <Spacer size={'md'} />
        <SelectField
          inputTitle="세입자 유무"
          value={mortgageInfo.tenantYn.text}
          placeholder={'세입자 유무'}
          onChangeSelectField={() => {}}
          onClickSelectField={() => onClickSelectField('Tenant20')}
        />

        <Spacer size={'md'} />
        <TextField
          inputTitle="보유 중인 대출 잔액"
          value={mortgageInfo.previousAmt ?? ''}
          placeholder={'0'}
          state={'enabled'}
          adornment={'만 원'}
          inputMode={'numeric'}
          helperText={currencyKR(mortgageInfo.previousAmt * 10000)}
          onChangeTextInput={(value) =>
            onChangeInput({ key: 'previousAmt', value })
          }
        />
        <Spacer size={'md'} />
        <TextField
          inputTitle="대출 희망 금액"
          value={mortgageInfo.hopefulAmt ?? ''}
          placeholder={'0'}
          state={'enabled'}
          adornment={'만 원'}
          helperText={currencyKR(mortgageInfo.hopefulAmt * 10000)}
          inputMode={'numeric'}
          onChangeTextInput={(value) =>
            onChangeInput({ key: 'hopefulAmt', value })
          }
        />
      </SideBox>
      <Height60 />
      <Spacer size="lg" />
      <FloatingBox>
        <Button
          flexible={true}
          configuration={'contained'}
          isDisabled={!isActive}
          state={isActive ? 'enabled' : 'disabled'}
          children={'다음'}
          onClick={onClickButton}
        />
      </FloatingBox>

      <Popup
        title={popup.message}
        confirmBtn={{
          text: popup.confirmText,
          onClick: popup.onClickConfirmButton,
        }}
        cancelBtn={{
          text: popup.cancelText,
          onClick: popup.onClickCancelButton,
        }}
        isPopupOpen={popup.isPopupOpen}
      />

      <MenuBottomsheet
        selectType="instant"
        isOpenBottomSheet={selectSheet.open}
        title={selectSheet.title}
        subTitle={selectSheet.subTitle}
        items={selectSheet.items}
        onClickMenuItem={(e: any) => {
          sendBeaconClkBtnOption({
            btmsheet_name: selectSheet.title,
            option_name: e.text,
            before_option_name: mortgageInfo[selectSheet.stateNm],
          });

          onChangeWrappingInput({
            key: selectSheet.stateNm,
            text: e.text,
            value: e.value,
          });

          selectSheet.onClose();
        }}
        onClickCloseMenuBottomsheet={selectSheet.onClose}
        defaultValue={mortgageInfo[selectSheet.stateNm]}
      />
    </>
  );
};
